import { render } from "./BaseUserMenu.vue?vue&type=template&id=5c7692c3"
import script from "./BaseUserMenu.vue?vue&type=script&lang=js"
export * from "./BaseUserMenu.vue?vue&type=script&lang=js"

import "./BaseUserMenu.vue?vue&type=style&index=0&id=5c7692c3&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__